import dayjs from 'dayjs';
import { Dialog } from '@alife/cn-ui';
import { useI18n } from '@alife/panda-i18n';
import React, { useState, useEffect } from 'react';
import { logCustom, logError } from 'src/utils/tracker';
import { getAppConfig, getQueryConfig } from 'src/utils/config';
import { getReleaseNoteDetail, getReleaseNoteList } from 'src/services';
import Content from './components/content';
import './index.scss';
export default function ReleaseNote(props) {
    const $i18n = useI18n();
    const [data, setData] = useState();
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [current, setCurrent] = useState();
    const language = $i18n.getLang();
    useEffect(() => {
        if (props.visible) {
            const params = getQueryConfig(getAppConfig()?.userSystem);
            getReleaseNoteList({ ...params, language }).then((res) => {
                const arr = res;
                setList(arr);
                let first = arr?.[0];
                if (first) {
                    toggleItem(first);
                }
            });
        }
    }, [props.visible]);
    const toggleItem = (item) => {
        setCurrent(item);
        // console.log('item', item);
        logCustom(`CLK_releaseNoteItem`, item.id, props.panelCode);
        setLoading(true);
        getReleaseNoteDetail({
            id: item.id,
        })
            .then((res) => {
            setData(res);
            setLoading(false);
        })
            .catch((err) => {
            logError(err, {
                c2: 'get release note detail fail'
            });
            setData(undefined);
            setLoading(false);
        });
    };
    const onClose = () => {
        props?.onClose();
    };
    const renderContent = () => {
        if (loading) {
            return (React.createElement("div", { className: 'cn-ui-intelli-assistant-release-note-content-excep' }, $i18n.get({ id: 'Loading', dm: '加载中...' })));
        }
        if (!data) {
            return React.createElement("div", { className: 'cn-ui-intelli-assistant-release-note-content-excep' }, $i18n.get({
                id: 'LoadFailedPleaseTryAgainLater_1651032900',
                dm: '加载失败， 请稍后重试',
            }));
        }
        if (!props.visible)
            return React.createElement(React.Fragment, null);
        return React.createElement(Content, { data: data });
    };
    return React.createElement(Dialog, { visible: props.visible, onCancel: onClose, onClose: onClose, className: "cn-ui-intelli-assistant-release-note-dialog", footer: false, title: $i18n.get({ id: 'UpdateRecords.ued', dm: '更新记录' }), width: '80%', height: '80%', closeMode: ['close', 'esc', 'mask'], style: {
            width: '80%',
            // height: '80%',
            minWidth: '500px',
            minHeight: '400px'
        } },
        React.createElement("div", { className: 'cn-ui-intelli-assistant-release-note-new-version' },
            React.createElement("div", { className: 'cn-ui-intelli-assistant-release-note-left' },
                React.createElement("ul", { className: 'cn-ui-intelli-assistant-release-note-list' }, list.map((item) => {
                    return (React.createElement("li", { key: item.id, className: `cn-ui-intelli-assistant-release-note-list-item ${current?.id === item.id ? 'selected' : ''}`, onClick: () => {
                            toggleItem(item);
                        } },
                        dayjs(item.releaseNotesTime).format($i18n.get({
                            id: 'YYYYYearMMonthDDay_626793450',
                            dm: 'YYYY年M月D日',
                        })),
                        $i18n.get({ id: 'UpdateContent', dm: '更新内容' })));
                }))),
            React.createElement("div", { className: 'cn-ui-intelli-assistant-release-note-right' },
                React.createElement("div", { className: 'cn-ui-intelli-assistant-release-note-title' },
                    React.createElement("div", { className: 'cn-ui-intelli-assistant-release-note-title-text' }, current?.label)),
                React.createElement("div", { className: 'cn-ui-intelli-assistant-release-note-content' }, renderContent()))));
}
